import { getItem } from "../services/localStorageService";
import { LOCAL_STORAGE_KEYS } from "../consts/constants";

export default function getToken() {
  return getItem(LOCAL_STORAGE_KEYS.AUTH_KEY) || "";
}
